var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg inherit",attrs:{"data-v-c421b3c4":"","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","color":"inherit"}},[_c('path',{attrs:{"d":"M4 9L8 5L12 9","fill":"none","stroke":"#121212","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }